/* eslint-disable import/no-anonymous-default-export */
import User from "pages/User";
import { USER_PAGE } from "routes/route.constant";

const route = {
  path: USER_PAGE,
  element: User,
};

export default route;
